"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    _clientAuth = require("@devsta/client-auth"),
    _reactFiles = _interopRequireDefault(require("react-files")),
    _Uploader = require("../../../../Uploader"),
    _Asset = _interopRequireDefault(require("./Asset"));

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var CommentAssets = function (a) {
  function b() {
    var a, d;
    (0, _classCallCheck2["default"])(this, b);

    for (var e = arguments.length, f = Array(e), g = 0; g < e; g++) {
      f[g] = arguments[g];
    }

    return (0, _possibleConstructorReturn2["default"])(d, (a = d = c.call.apply(c, [this].concat(f)), d.handleFilesChange = function () {
      var a = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a(b) {
        var c, e, f, g, h;
        return _regenerator["default"].wrap(function (a) {
          for (;;) {
            switch (a.prev = a.next) {
              case 0:
                if (c = d.props.onFilesChange, b.length) {
                  a.next = 3;
                  break;
                }

                return a.abrupt("return");

              case 3:
                return e = d.props, f = e.addFileToQueue, g = e.assetIds, a.next = 6, Promise.all(b.map(function (a) {
                  return f({
                    file: a
                  });
                }));

              case 6:
                h = a.sent, d._filePickerRef.removeFiles(), c([].concat((0, _toConsumableArray2["default"])(g), (0, _toConsumableArray2["default"])(h)));

              case 9:
              case "end":
                return a.stop();
            }
          }
        }, a);
      }));
      return function () {
        return a.apply(this, arguments);
      };
    }(), d.setFilePickerRef = function (a) {
      d._filePickerRef || !a || (d._filePickerRef = a);
    }, d.deleteAsset = function (a) {
      return function (b) {
        var c = d.props,
            e = c.updateComment,
            f = c.assetIds,
            g = c.commentId,
            h = c.onFilesChange;
        b.stopPropagation();
        var i = (0, _toConsumableArray2["default"])(f);
        i.splice(a, 1), h(i), g && e(g, {
          assetIds: i
        });
      };
    }, a));
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "render",
    value: function render() {
      var a = this,
          b = this.props,
          c = b.assetIds,
          d = b.canAdd,
          e = b.canDelete,
          f = _clientAuth.credentials.get(),
          g = f.user.isAnonymous;

      return _react["default"].createElement("div", {
        className: "comment-assets"
      }, c.map(function (b, c) {
        return _react["default"].createElement(_Uploader.AssetSelector, {
          key: b,
          assetId: b
        }, function (b) {
          return null === b ? _react["default"].createElement(_uiKit.Icon, {
            className: "comment-assets__deleted",
            name: "corrupt",
            size: 25,
            color: "michael"
          }) : _react["default"].createElement(_Asset["default"], {
            asset: b,
            deleteAsset: e && a.deleteAsset(c)
          });
        });
      }), d && !g && _react["default"].createElement(_reactFiles["default"], {
        onChange: this.handleFilesChange,
        accepts: ["image/*", "video/*"],
        minFileSize: 1,
        clickable: !0,
        ref: this.setFilePickerRef,
        multiple: !0
      }, _react["default"].createElement(_uiKit.Icon, {
        name: "attachment",
        size: 20,
        hoverColor: "black",
        color: "denim",
        className: "comment-assets__placeholder"
      })));
    }
  }]), b;
}(_react.Component),
    _default = CommentAssets;

exports["default"] = _default;